export const TEACHERS_LIST = [
  {
    id: 249,
    created_at: 1691065485514,
    firstName: 'Cynthia',
    lastName: 'Lewis',
    email: 'cynthia.l@teacher.com',
    school_indentity_number: '',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1557903600000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,


      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 235,
    created_at: 1691056045609,
    firstName: 'Jessica',
    lastName: 'Robinson',
    email: 'jessica.r@teacher.com',
    school_indentity_number: '788787877',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1564642800000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,


      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3761,
    created_at: 1707075287000,
    firstName: 'Dorothy',
    lastName: 'Wilson',
    email: 'dorothy.w@teacher.com',
    school_indentity_number: 'ii7WLQQa',
    role_id: 9,
    school_id: 47,
    isNewUser: false,
    user_profile_media_id: 0,
    contact: 4569871256,
    address: '',
    birthdate: 634242600000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,

      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3833,
    created_at: 1707319499456,
    firstName: 'Louis',
    lastName: 'Diaz',
    email: 'louis.d@teacher.com',
    school_indentity_number: 'george451236',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 665422042000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,


      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3718,
    created_at: 1698342379962,
    firstName: 'Jeremy',
    lastName: 'Wood',
    email: 'jeremy.w@teacher.com',
    school_indentity_number: 'harry1243',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 816508800000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,

      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3669,
    created_at: 1697448028099,
    firstName: 'Leon',
    lastName: 'Palmer',
    email: 'leon.p@teacher.com',
    school_indentity_number: '458756321545',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 532204200000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,

      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3737,
    created_at: 1698935925926,
    firstName: 'Ruben',
    lastName: 'Hawkins',
    email: 'ruben.h@teacher.com',
    school_indentity_number: 'kevin12342',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 1572591600000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,

      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 802,
    created_at: 1692708528499,
    firstName: 'Keri',
    lastName: 'Dalton',
    email: 'keri.d@teacher.com',
    school_indentity_number: '789654345675',
    role_id: 9,
    school_id: 47,
    isNewUser: false,

    user_profile_media_id: 0,
    contact: 5345353535,
    address: 'california',
    birthdate: 969778800000,
    isDisable: true,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 47,
      created_at: 1691055449788,
      name: 'Wipro International School',
      city: 'Beebe',
      state: 'Arkansas',
      country: 'United States',
      code: 'GzE1oY4x',
      phone: 6788889999,

      start_time: 1690981200000,
      end_time: 1691184600000,
      start_date: 1654066800000,
      end_date: 1693465200000,
      isNew: false,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 19,
      isSchoolOnboarded: true,
      user_limitations: [
        {
          role: 'student',
          isLimitedAccess: 'true',
        },
        {
          role: 'teacher',
          isLimitedAccess: 'true',
        },
        {
          role: 'other_user',
          isLimitedAccess: 'true',
        },
      ],
      is_trial_school: null,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },

];
